import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconShare = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 21,
	height: 22,
	viewBox: "0 0 21 22",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.415 5.71875L10.333 2.63672L7.25098 5.71875L6.43848 4.90234L10.333 1.00781L14.2275 4.90234L13.415 5.71875Z",
			fill: "#03314B",
			stroke: "#03314B",
			strokeWidth: .5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.915 1.82031H9.75098V14.0313H10.915V1.82031Z",
			fill: "#03314B",
			stroke: "#03314B",
			strokeWidth: .5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.1455 21.0078H4.52051C3.53223 21.0078 2.77441 20.25 2.77441 19.2617V8.79687C2.77441 7.80859 3.52832 7.05078 4.52051 7.05078H8.59082V8.21484H4.52051C4.17285 8.21484 3.93848 8.44922 3.93848 8.79687V19.2617C3.93848 19.6094 4.17285 19.8438 4.52051 19.8438H16.1494C16.4971 19.8438 16.7314 19.6094 16.7314 19.2617V8.79687C16.7314 8.44922 16.4971 8.21484 16.1494 8.21484H12.0791V7.05078H16.1494C17.1377 7.05078 17.8955 7.80469 17.8955 8.79687V19.2617C17.8916 20.25 17.1338 21.0078 16.1455 21.0078Z",
			fill: "#03314B",
			stroke: "#03314B",
			strokeWidth: .5
		})
	]
});
export default SvgIconShare;
